export default "__VITE_ASSET__BF$y5Hec__"